import React,{Component} from 'react'
import { render } from 'react-dom';
import { Link, BrowserRouter as Router, Route, Switch, useRouteMatch, useHistory } from "react-router-dom";
import ScrollToTop from "../../Components/ScrolltoTop";
import Login from "../../Log-in/Login"
import Reset from '../../Log-in/Reset'
import Signup from '../../Log-in/Sign';
import Wallets from "../../Wallet_pg/Wallet"
import com_logo from "../../Home/Home_modules/Im/com_logo.png"
import "./navbar.css";
import Homemain from '../Home_modules/Main';
import About from '../../Pages/About/About';
import Collections from "../../Pages/Collections/Collections"
import nftdetail from "../../Pages/nftdetail/nftdetail"; 
import nftshowcase from "../../Pages/nftdetail/nftshowcase";
import nfttransfer from "../../Pages/nftdetail/nfttransfer";
import Nft_conformation from "../../Pages/Nft_conformation/Nft_conformation";
import Bid_conformation from "../../Pages/Bid_conformation/Bid_conformation";
import How_it_works from "../../Pages/How_it_works/How_it_works";
import Marketplace from '../../Pages/Marketplace/Marketplace';
import NFT_Final_full from '../../Pages/NTF_Final/NFT_Final_full/NFT_Final_full';
import Collections_sub from '../../Pages/collections-sub/Collections_sub';
import Navbar from './Navbar';
import Profile_pg from '../../Pages/Profile/Profile_pg';
import wallet_connect from '../../wallet_connect/wallet_connect';
import fortmatic from '../../fortmatic/fortmatic';
import Place_a_bid  from '../../Pages/Place_a_bid/Placeabid';
import Nft_product from '../../Pages/Nft_products/Nft_product';
import { id } from '@ethersproject/hash';
import Product from '../../Pages/Nft_products/Nft_product';
import Page_not_found from '../../Pages/Page_not_found/Page_not_found';
import AuthProvider from '../../Auth';
import Web3 from 'web3';
import Web3Provider from 'react-web3-provider';
import Blog from '../../Pages/Blog/Blog';
import Blog_inner from '../../Pages/Blog/Blog_inner';
import Contact from '../../Pages/Contact/Contact';
import Termscondition from '../../Pages/Termscondition/Termscondition'
import Privacypolicy from '../../Pages/Privacypolicy/Privacypolicy'
import Chandramukhi from '../../Pages/collections-sub/Chandramukhi';
import Kabali from '../../Pages/collections-sub/Kabali';
import Sivaji from '../../Pages/collections-sub/Sivaji';
import Edit_Profile from '../../Pages/Profile/edit_profile';
import Lottery from '../../Pages/Lottery/lottery_main';
import Lottery_inner from '../../Pages/Lottery/lottery_inner';
import Lotterypop from '../../Pages/Lottery/pop';
import Lottery_purchased from '../../Pages/Lottery/lottery_purchased';
import Market from '../../Pages/Marketplace/market';
import Footer from '../../Home/Home_modules/Footerr/footer';
import transfer from '../../Pages/nftdetail/transfernft';
import spb from '../../Pages/Spbdrop/spb';
import test from '../../Pages/nftdetail/testapi.jsx';
import spbdrop from '../../Pages/Spbdrop/spbdrop';
import paymentstatus from '../../Pages/nftdetail/Status';
import PasumaiNayaganVivek from "../../Pages/collections-sub/PasumaiNayaganVivek"

class Nav_path extends React.Component {
   render(){ return (
        <AuthProvider>
        <Router>
        <ScrollToTop>
            <Switch>
                <Route exact path="/resetpass">
                    <Reset />
                </Route>
                <Route exact path="/signup">
                    <Signup />
                </Route>
                <Route exact path="/login">
                    <Login />
                </Route>
                <Route exact path="/wallet">
                    <Wallets />
                </Route>
                <div>
                    <Navbar />
                    <Route exact path="/">
                        <Homemain></Homemain>
                    </Route>
                    <Route exact path="/about">
                        <About></About>
                    </Route>
                    <Route exact path="/collections">
                        <Collections></Collections>
                    </Route>
                    <Route exact path="/how it works">
                        <How_it_works />
                    </Route>
                    <Route path={"/nftdetail/:nftid"} component ={nftdetail}></Route>
                    <Route path={"/nftshowcase/:nftid"} component ={nftshowcase}></Route>
                    <Route path={"/nfttransfer/:nftid"} component ={nfttransfer}></Route>
                    <Route path={"/transfer/:nftid"} component ={transfer}></Route>
                    <Route path={"/confirmation/:nftid/:uuid"} component ={Nft_conformation}></Route>
                    <Route path={"/Bid_conformation/:nftid"} component ={Bid_conformation}></Route>
                    <Route path={"/wallet_connect/"} component ={wallet_connect}></Route>
                    <Route path={"/fortmatic/"} component ={fortmatic}></Route>
                    <Route exact path="/marketplace">
                        <Marketplace></Marketplace>
                    </Route>
                    <Route exact path="/wallet">
                        <Wallets />
                    </Route>
                    <Route exact path="/blog">
                        <Blog />    
                        </Route>
                    <Route path={"/blog/:postSlug"} component={Blog_inner} ></Route>
                    <Route exact path="/collections-sub">
                        <Collections_sub />
                    </Route>
                    <Route exact path="/profile">
                        <Profile_pg/>
                    </Route>
                    <Route exact path="/nft_conformation">
                        <Nft_conformation/>
                    </Route>
                    <Route exact path="/place_a_bid">
                        <Place_a_bid />
                        </Route>
                    <Route exact path="/contact">
                        <Contact />
                    </Route>
                    <Route exact path="/Termscondition">
                        <Termscondition />
                    </Route>
                    <Route exact path="/Privacypolicy">
                        <Privacypolicy />
                    </Route>
                    <Route exact path="/chandramukhi">
                        <Chandramukhi />
                    </Route>
                    <Route exact path="/kabali">
                        <Kabali />
                    </Route>
                    <Route exact path="/sivaji">
                        <Sivaji />
                    </Route>
                    <Route exact path="/edit_profile">
                        <Edit_Profile />
                    </Route>
                    <Route exact path="/lottery">
                        <Lottery />
                    </Route>
                    <Route path={"/lottery/:id"} component={Lottery_inner}></Route>
                    <Route path="/lottery_pop" component={Lotterypop}></Route>
                    <Route path="/market" component={Market}></Route>
                    <Route path="/footer" component={Footer}></Route>
                    <Route path={"/lottery_confirmation/:id"} component={Lottery_purchased}></Route>
                    
                    <Route path='/ptest' component={test}></Route>
                    <Route path='/nonfungiblespb' component={spbdrop}></Route>
                    <Route path='/pasumainayaganvivek' component={PasumaiNayaganVivek}></Route>
                    <Route path='/paymentstatus/:nftid/:order_id/:order_token' component={paymentstatus}></Route>
                </div>
            </Switch>
            </ScrollToTop>
        </Router>
        </AuthProvider>
    )
   }
}

export default Nav_path
